import React, {useState} from 'react';
import {useSpring, animated} from 'react-spring';
import {Keyframes, config} from 'react-spring/renderprops';
import {mapStateToProps, mapDispatchToProps} from "../redux/redux";
import {connect} from 'react-redux';

const delay = (time) => {
    new Promise((resolve) => {
        setTimeout(resolve, time)
    })
}

let toggle = 0;

const Hover = Keyframes.Spring( async next => {
    while(!toggle) {
        await next({transform: "translate(0em, 0em)"})
        if (!toggle) await delay(1000)
        if (!toggle) await next({transform: "translate(-2em, 0em)", config: {mass: 0.3, tension: 141, friction: 17}})
        if (!toggle) await delay(500)
        if (!toggle) await next({transform: "translate(3em, 0em)", config: {mass: 0.1, tension: 396, friction: 11}})
        if (!toggle) await next({transform: "translate(-2em, 0em)", config: {mass: 0.1, tension: 396, friction: 11}})
        if (!toggle) await next({transform: "translate(1em, 0em)", config: {mass: 0.1, tension: 396, friction: 11}})
        if (!toggle) await next({transform: "translate(-0em, 0em)", config: config.wobbly})
    }
    next({transform: "translate(0em, 0em)", config: {mass: 0.5, tension: 141, friction: 20}})
})

function HoverAnimationPre(props) {

    const [pop, set, stop] = useSpring(() => ({height: "4.7em", transform: "translate(0em, 0em)", from: {height: "2em", transform: "translate(0em, -4em)"}, config: config.gentle}));

    function popOver() {
        toggle = 1;
        setTimeout(() => props.updateState({hoverAnimation: false}), 1000);
        setTimeout(() => set({height: "2em", transform: "translate(0em, -4em)", config: config.gentle}), 500)
    }

        return(
            <div className="hoverAnimation">
                <animated.h1 style={pop} onMouseEnter={popOver}>
            <Hover>{style => <h1 style={{...style, fontSize: "1em"}} className="display-4">Hover</h1>}</Hover>
                    </animated.h1>
            </div>
        )
}

let HoverAnimation = (connect)(mapStateToProps, mapDispatchToProps)(HoverAnimationPre);
export default HoverAnimation;